<template>
    <div>
        <slot name="dialogBtn" />
        <el-dialog
            :title="titleTxt"
            :class="isChineseEvn ? 'cn-dialog' : 'en-dialog'"
            width="500px"
            :append-to-body="true"
            :destroy-on-close="true"
            :visible.sync="dialogVisible"
            v-if="dialogVisible"
        >
            <el-form ref="form" :model="form" :rules="rules" label-width="100px" label-position="left">
                <el-form-item :label="$i18n.t('zhiji.portrait.tagName')" prop="name" class="prop-item">
                    <el-input v-model="form.name" :placeholder="$i18n.t('zhiji.portrait.writeHold')" />
                </el-form-item>
                <el-form-item :label="$i18n.t('zhiji.portrait.tagDesc')" prop="describe" class="prop-item">
                    <el-input v-model="form.describe" :placeholder="$i18n.t('zhiji.portrait.desHold')" />
                </el-form-item>
                <el-form-item :label="$i18n.t('zhiji.portrait.useType')" prop="useType" class="prop-item">
                    <el-checkbox-group v-model="form.useType">
                        <el-checkbox label="1" name="useType"> {{ $i18n.t("zhiji.portrait.moreAwsPortrait") }} </el-checkbox>
                        <el-checkbox label="2" name="useType"> {{ $i18n.t("zhiji.portrait.textPortraitTag") }} </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button round size="" @click="dialogVisible = false">
                    {{ $i18n.t("zhiji.common.cancel") }}
                </el-button>
                <el-button round size="" type="primary" @click="submit">
                    {{ $i18n.t("zhiji.common.confirm") }}
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { addClass, updateClass } from "../../service";

export default {
    name: "TagEdit",
    props: {
        data: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            dialogVisible: false,
            form: this.data.tagData,
            isChineseEvn: false
        };
    },
    computed: {
        titleTxt() {
            return this.data.type === "edit" ? this.$i18n.t("zhiji.portrait.editClassify") : this.$i18n.t("zhiji.portrait.createClassify");
        },
        rules() {
            return {
                name: [
                    {
                        required: true,
                        trigger: "blur",
                        message: this.$i18n.t("zhiji.portrait.rules.name")
                    }
                ],
                describe: [
                    {
                        required: true,
                        trigger: "blur",
                        message: this.$i18n.t("zhiji.portrait.rules.desc")
                    }
                ],
                useType: [
                    {
                        type: "array",
                        required: true,
                        message: this.$i18n.t("zhiji.portrait.rules.useType"),
                        trigger: "change"
                    }
                ]
            };
        }
    },
    watch: {
        dialogVisible(val) {
            // eslint-disable-next-line no-unused-expressions
            !val && this.$refs.form && this.$refs.form.resetFields();
        },
        data: {
            handler(val) {
                this.form = val.tagData;
            },
            deep: true,
            immediate: true
        },
        titleTxt() {
            this.isChineseEvn = localStorage.getItem("locale") === "cn" ? true : false;
        }
    },
    mounted() {
        this.isChineseEvn = localStorage.getItem("locale") === "cn" ? true : false;
        this.$slots.dialogBtn[0].elm.addEventListener("click", () => {
            this.dialogVisible = true;
        });
    },
    destroyed() {
        this.$slots.dialogBtn[0].elm.removeEventListener("click", () => {
            this.dialogVisible = false;
        });
    },
    methods: {
        submit() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.saveAction();
                } else {
                    return false;
                }
            });
        },
        saveAction() {
            const handlers = {
                edit: this.editAction,
                add: this.addAction
            };
            handlers[this.data.type].call(null);
        },
        addAction() {
            addClass(this.form).then(() => {
                this.dialogVisible = false;
                this.$emit("submit", this.form);
            });
        },
        editAction() {
            updateClass(this.form).then(() => {
                this.dialogVisible = false;
                this.$emit("submit", this.form);
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.prop-item:last-child {
    margin-bottom: 0;
}

.en-dialog{
    /deep/.el-form-item__label{
        width: 150px !important;
    }
    /deep/.el-form-item__content{
        margin-left: 150px !important;
    }
}
</style>
